import type { WorkAdvisoryReportData } from "@/types/workadvisory";

/**
 * Normaliza el `data` de un informe al cruzar de JSON a React. La columna es
 * `Json`, así que la garantía de TypeScript se acaba en la BD: un informe
 * guardado con una forma anterior llega sin los campos nuevos y revienta la
 * pantalla al leer `.length`.
 */
export function normalizeReportData(raw: unknown): WorkAdvisoryReportData {
  const data = (raw ?? {}) as Partial<WorkAdvisoryReportData> & {
    // Nombre anterior de `excludedWorks`. Se puede borrar cuando no queden
    // borradores generados antes del rename.
    unpricedWorks?: WorkAdvisoryReportData["excludedWorks"];
  };

  return {
    funnel: data.funnel ?? [],
    byDepartment: data.byDepartment ?? [],
    works: data.works ?? [],
    excludedWorks: data.excludedWorks ?? data.unpricedWorks ?? [],
  };
}
